<template>
  <div class="modal-content-install-app">
    <div class="modal-content-install-app__header">
      <tab-install-app v-model="currentTab" />
    </div>

    <div class="modal-content-install-app__body">
      <modal-content-install-app-android
        v-if="currentTab === InstallAppTabs.ANDROID"
      />

      <modal-content-install-app-ios
        v-if="currentTab === InstallAppTabs.IOS"
      />

      <modal-content-install-app-windows
        v-if="currentTab === InstallAppTabs.WINDOWS"
      />

      <modal-content-install-app-macos
        v-if="currentTab === InstallAppTabs.MACOS"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { InstallAppTabs } from '@skeleton/consts/tabs/install-app-tabs';

  const globalStore = useGlobalStore();
  const { osPlatform } = storeToRefs(globalStore);

  const currentTab = ref(InstallAppTabs.ANDROID);

  onMounted(() => {
    if (typeof window !== 'undefined' && window.navigator) {
      switch (osPlatform.value) {
        case "Windows": {
          currentTab.value = InstallAppTabs.WINDOWS;
          break;
        }

        case "iOS": {
          currentTab.value = InstallAppTabs.IOS;
          break;
        }

        case "Mac OS" : {
          currentTab.value = InstallAppTabs.MACOS;
          break;
        }

        default: {
          currentTab.value = InstallAppTabs.ANDROID;
        }
      }
    }
  });

</script>

<style src="~/assets/styles/components/modal-content/install-app.scss" lang="scss" />
